(function () {
  const MACHINE_OPTIONS = [
    { id: 'ict_808_1200', name: 'ict 808 – 1200 W', cost: 6400 },
    { id: 'press11_massage', name: 'Press11 Massage', cost: 2100 },
    { id: 'press11ir_massage', name: 'Press11IR Massage', cost: 2300 },
    { id: 'press11ir_massage_el', name: 'Press11IR Massage EL', cost: 2450 },
    { id: 'oxy_technology', name: 'OXY Technology', cost: 1250 },
    { id: 'digital_pro_skin_check', name: 'Digital Pro Skin Check', cost: 900 },
    { id: 'beauty_face', name: 'Beauty Face', cost: 2400 }
  ];

  const CLASS_CONFIG = {
    A: {
      id: 'A',
      label: 'A',
      title: 'Premium / alta marginalita',
      targetMargin: 0.55,
      presets: [12, 24, 36, 48, 60]
    },
    B: {
      id: 'B',
      label: 'B',
      title: 'Equilibrata',
      targetMargin: 0.50,
      presets: [12, 24, 36, 48, 60]
    },
    C: {
      id: 'C',
      label: 'C',
      title: 'Commerciale',
      targetMargin: 0.45,
      presets: [12, 24, 36, 48, 60]
    }
  };

  const CLASS_SEQUENCE = ['A', 'B', 'C'];
  const PRODUCT_MARGIN_RATE = 0.65;
  const PRODUCT_COST_RATE = 0.35;
  const MIN_SUSTAINABLE_MARGIN = 0.33;
  const REVENUE_THRESHOLD_FOR_60_MONTHS = 20000;
  const ANNUAL_MAINTENANCE_COST = 250;
  const MIN_RATE = 50;
  const RATE_STEP = 5;
  const WHATSAPP_BUSINESS_NUMBER = '393337759669';
  const STORAGE_KEYS = {
    proposals: 'els_rental_proposals_v1',
    currentId: 'els_rental_current_proposal_id_v1'
  };

  const DEFAULT_CONTRACT = {
    agreementNumber: '',
    businessName: '',
    vatCode: '',
    contactPerson: '',
    phone: '',
    emailPec: '',
    installationAddress: '',
    programContent: '',
    equipment: '',
    machineValue: '',
    installationDate: '',
    duration: '',
    programEnd: '',
    monthlyMinimum: '',
    paymentMethod: 'RID / bonifico',
    invoiceDueDate: '30 gg data fattura',
    toleranceMonths: '2'
  };

  const DEFAULT_STATE = {
    proposalId: '',
    agreementNumber: '',
    machineId: 'beauty_face',
    secondaryMachineId: '',
    classId: 'A',
    desiredRate: 450,
    targetRevenue: 10800,
    targetMargin: 0.55,
    financialAdjustedValue: 0,
    selectedMonths: 24,
    activeMode: 'rate',
    includeDeliveryReport: false,
    includePrivacyModule: false,
    contract: { ...DEFAULT_CONTRACT },
    programContentDirty: false,
    updatedAt: ''
  };

  const app = document.querySelector('[data-ordine-rental-app]');
  if (!app) return;

  const elements = {
    machine: app.querySelector('[data-rental-machine]'),
    secondaryMachine: app.querySelector('[data-rental-secondary-machine]'),
    classButtons: Array.from(app.querySelectorAll('[data-rental-class]')),
    classCopy: app.querySelector('[data-rental-class-copy]'),
    rate: app.querySelector('[data-rental-rate]'),
    revenue: app.querySelector('[data-rental-revenue]'),
    margin: app.querySelector('[data-rental-margin]'),
    rateValidation: app.querySelector('[data-rental-rate-validation]'),
    revenueValidation: app.querySelector('[data-rental-revenue-validation]'),
    marginValidation: app.querySelector('[data-rental-margin-validation]'),
    financialAdjusted: app.querySelector('[data-rental-financial-adjusted]'),
    includeDelivery: app.querySelector('[data-rental-include-delivery]'),
    includePrivacy: app.querySelector('[data-rental-include-privacy]'),
    activeMode: app.querySelector('[data-rental-active-mode]'),
    monthsPicker: app.querySelector('[data-rental-months-picker]'),
    messages: app.querySelector('[data-rental-messages]'),
    statusBadge: app.querySelector('[data-rental-status-badge]'),
    statusDetail: app.querySelector('[data-rental-status-detail]'),
    commercialNote: app.querySelector('[data-rental-commercial-note]'),
    summaryPanel: app.querySelector('[data-rental-summary-panel]'),
    save: app.querySelector('[data-rental-save]'),
    generate: app.querySelector('[data-rental-generate]'),
    print: app.querySelector('[data-rental-print]'),
    whatsapp: app.querySelector('[data-rental-whatsapp]'),
    newProposal: app.querySelector('[data-rental-new]'),
    savedState: app.querySelector('[data-rental-saved-state]'),
    outputs: {
      machine: app.querySelector('[data-rental-output-machine]'),
      machineCost: app.querySelector('[data-rental-output-machine-cost]'),
      machineTotal: app.querySelector('[data-rental-output-machine-total]'),
      classLabel: app.querySelector('[data-rental-output-class]'),
      rateDesired: app.querySelector('[data-rental-output-rate-desired]'),
      revenueTarget: app.querySelector('[data-rental-output-revenue-target]'),
      monthsTheoretical: app.querySelector('[data-rental-output-months-theoretical]'),
      monthsSelected: app.querySelector('[data-rental-output-months-selected]'),
      rateFinal: app.querySelector('[data-rental-output-rate-final]'),
      revenue: app.querySelector('[data-rental-output-revenue]'),
      productsCost: app.querySelector('[data-rental-output-products-cost]'),
      marginValue: app.querySelector('[data-rental-output-margin-value]'),
      marginPercent: app.querySelector('[data-rental-output-margin-percent]'),
      formula: app.querySelector('[data-rental-output-formula]'),
      enteredMarginValue: app.querySelector('[data-rental-output-entered-margin-value]'),
      enteredMarginPercent: app.querySelector('[data-rental-output-entered-margin-percent]'),
      financialMarginValue: app.querySelector('[data-rental-output-financial-margin-value]'),
      financialMarginPercent: app.querySelector('[data-rental-output-financial-margin-percent]')
    },
    formulaBox: app.querySelector('[data-rental-formula-box]'),
    deliveryPages: Array.from(app.querySelectorAll('[data-rental-delivery-page], [data-rental-delivery-extra-page]')),
    contractInputs: Array.from(app.querySelectorAll('[data-rental-contract]')),
    previewAgreement: app.querySelector('[data-rental-preview-agreement]'),
    previewFields: Array.from(app.querySelectorAll('[data-rental-preview]')).reduce((acc, node) => {
      const key = node.getAttribute('data-rental-preview');
      acc[key] = acc[key] || [];
      acc[key].push(node);
      return acc;
    }, {})
  };

  let state = loadState();

  init();

  function init() {
    renderMachineOptions();
    bindEvents();
    normalizeSelectionState();
    hydrateForm();
    render();
  }

  function bindEvents() {
    elements.machine.addEventListener('change', () => {
      state.machineId = elements.machine.value;
      if (state.secondaryMachineId === state.machineId) {
        state.secondaryMachineId = '';
      }
      syncDerivedContractFields();
      render();
    });

    if (elements.secondaryMachine) {
      elements.secondaryMachine.addEventListener('change', () => {
        state.secondaryMachineId = elements.secondaryMachine.value;
        if (state.secondaryMachineId === state.machineId) {
          state.secondaryMachineId = '';
        }
        syncDerivedContractFields();
        render();
      });
    }

    elements.classButtons.forEach((button) => {
      button.addEventListener('click', () => {
        state.classId = button.getAttribute('data-rental-class');
        state.targetMargin = getCurrentClass().targetMargin;
        state.activeMode = 'class';
        normalizeSelectionState();
        syncDerivedContractFields();
        render();
      });
    });

    elements.rate.addEventListener('input', () => {
      const parsed = parseNumber(elements.rate.value);
      state.desiredRate = parsed;
      if (state.selectedMonths) {
        state.targetRevenue = parsed * state.selectedMonths;
      }
      state.activeMode = 'rate';
      normalizeSelectionState();
      syncDerivedContractFields();
      render();
    });

    elements.revenue.addEventListener('input', () => {
      const parsed = parseNumber(elements.revenue.value);
      state.targetRevenue = parsed;
      state.activeMode = 'revenue';
      normalizeSelectionState();
      syncDerivedContractFields();
      render();
    });

    elements.margin.addEventListener('input', () => {
      state.targetMargin = clampMarginPercent(parseNumber(elements.margin.value) / 100);
      state.activeMode = 'margin';
      normalizeSelectionState();
      syncDerivedContractFields();
      render();
    });

    if (elements.financialAdjusted) {
      elements.financialAdjusted.addEventListener('input', () => {
        state.financialAdjustedValue = parseNumber(elements.financialAdjusted.value);
        render();
      });
    }

    if (elements.includeDelivery) {
      elements.includeDelivery.addEventListener('change', () => {
        state.includeDeliveryReport = elements.includeDelivery.checked;
        renderPreview();
      });
    }

    if (elements.includePrivacy) {
      elements.includePrivacy.addEventListener('change', () => {
        state.includePrivacyModule = elements.includePrivacy.checked;
        renderPreview();
      });
    }

    elements.save.addEventListener('click', () => {
      saveProposal(false);
    });

    elements.generate.addEventListener('click', () => {
      saveProposal(true);
      app.querySelector('[data-rental-print-preview]').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    elements.print.addEventListener('click', () => {
      if (!state.agreementNumber) {
        saveProposal(false);
      }
      syncDerivedContractFields();
      render();
      window.print();
    });

    elements.whatsapp.addEventListener('click', () => {
      openWhatsAppShare();
    });

    elements.newProposal.addEventListener('click', () => {
      const confirmed = window.confirm('Creare una nuova bozza? La bozza corrente restera salvata solo se hai gia cliccato "Salva bozza".');
      if (!confirmed) return;
      state = createDefaultState();
      persistCurrentId('');
      hydrateForm();
      render();
    });

    elements.contractInputs.forEach((input) => {
      input.addEventListener('input', () => {
        const field = input.getAttribute('data-rental-contract');
        state.contract[field] = input.value;
        if (field === 'programContent') {
          state.programContentDirty = true;
        }
        if (field === 'installationDate') {
          syncDerivedContractFields();
          hydrateContractInputs();
        }
        renderPreview();
      });
    });
  }

  function renderMachineOptions() {
    elements.machine.innerHTML = MACHINE_OPTIONS.map((machine) => (
      `<option value="${machine.id}">${escapeHtml(machine.name)} — ${formatCurrency(machine.cost)}</option>`
    )).join('');

    if (elements.secondaryMachine) {
      elements.secondaryMachine.innerHTML = [
        '<option value="">Nessuna seconda apparecchiatura</option>',
        ...MACHINE_OPTIONS.map((machine) => (
          `<option value="${machine.id}">${escapeHtml(machine.name)} — ${formatCurrency(machine.cost)}</option>`
        ))
      ].join('');
    }
  }

  function hydrateForm() {
    const rateDefault = Number.isFinite(state.desiredRate) && state.desiredRate > 0
      ? roundToCommercialRate(state.desiredRate)
      : MIN_RATE;
    const revenueDefault = Number.isFinite(state.targetRevenue) && state.targetRevenue > 0
      ? roundToCommercialRate(state.targetRevenue)
      : '';

    elements.machine.value = state.machineId;
    if (elements.secondaryMachine) {
      elements.secondaryMachine.value = state.secondaryMachineId && state.secondaryMachineId !== state.machineId
        ? state.secondaryMachineId
        : '';
    }
    if (document.activeElement !== elements.rate) {
      elements.rate.value = String(rateDefault);
    }
    if (document.activeElement !== elements.revenue) {
      elements.revenue.value = String(revenueDefault);
    }
    if (document.activeElement !== elements.margin) {
      elements.margin.value = formatPercentInput(state.targetMargin || getCurrentClass().targetMargin);
    }
    if (elements.financialAdjusted) {
      elements.financialAdjusted.value = state.financialAdjustedValue || '';
    }
    if (elements.includeDelivery) {
      elements.includeDelivery.checked = Boolean(state.includeDeliveryReport);
    }
    if (elements.includePrivacy) {
      elements.includePrivacy.checked = Boolean(state.includePrivacyModule);
    }
    hydrateContractInputs();
  }

  function hydrateContractInputs() {
    syncDerivedContractFields();
    elements.contractInputs.forEach((input) => {
      const field = input.getAttribute('data-rental-contract');
      input.value = state.contract[field] || '';
    });
  }

  function render() {
    const result = computeState();

    renderClassState(result);
    renderMonths(result);
    renderMessages(result);
    renderOutputs(result);
    renderStatus(result);
    syncDerivedContractFields(result);
    hydrateContractInputs();
    renderPreview();
    renderSavedState();
  }

  function renderClassState(result) {
    elements.classButtons.forEach((button) => {
      const isActive = button.getAttribute('data-rental-class') === state.classId;
      button.classList.toggle('is-active', isActive);
    });
    elements.classCopy.textContent = `${result.classConfig.label} · target ${formatPercent(result.classConfig.targetMargin)} · margine minimo ${formatPercent(MIN_SUSTAINABLE_MARGIN)}`;
    if (!state.selectedMonths) {
      elements.activeMode.textContent = 'Seleziona i mesi';
      return;
    }
    const modeLabels = {
      revenue: 'Da fatturato',
      margin: 'Da margine',
      class: 'Da classe',
      rate: 'Da rata'
    };
    elements.activeMode.textContent = `${modeLabels[state.activeMode] || modeLabels.rate} · ${state.selectedMonths} mesi`;
  }

  function renderMonths(result) {
    elements.monthsPicker.innerHTML = result.classConfig.presets.map((months) => {
      const active = state.selectedMonths === months;
      const disabled = !isDurationAllowed(months, result);
      return `<button type="button" class="ordine-rental__month-btn${active ? ' is-active' : ''}" data-months="${months}"${disabled ? ' disabled' : ''}>${months} mesi</button>`;
    }).join('');

    Array.from(elements.monthsPicker.querySelectorAll('[data-months]')).forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        state.selectedMonths = parseInt(button.getAttribute('data-months'), 10);
        if (state.activeMode === 'rate') {
          state.targetRevenue = state.desiredRate * state.selectedMonths;
        }
        syncDerivedContractFields();
        render();
      });
    });
  }

  function renderMessages(result) {
    const messages = [];

    if (result.rateValidation) {
      messages.push({ tone: 'error', text: result.rateValidation });
    }

    if (result.durationValidation) {
      messages.push({ tone: 'error', text: result.durationValidation });
    }

    if (result.activeMonths && result.isBelowMinimumMargin) {
      messages.push({ tone: 'error', text: 'Margine non sostenibile' });
    } else if (result.activeMonths) {
      messages.push({ tone: 'ok', text: 'Calcolo sostenibile' });
    }

    elements.messages.innerHTML = messages.map((message) => (
      `<div class="ordine-rental__message ordine-rental__message--${message.tone}">${escapeHtml(message.text)}</div>`
    )).join('');

    elements.rateValidation.hidden = !result.rateValidation;
    elements.rateValidation.textContent = result.rateValidation || '';
    elements.revenueValidation.hidden = !result.revenueValidation;
    elements.revenueValidation.textContent = result.revenueValidation || '';
    elements.marginValidation.hidden = !result.marginValidation;
    elements.marginValidation.textContent = result.marginValidation || '';
  }

  function renderOutputs(result) {
    if (document.activeElement !== elements.rate) {
      elements.rate.value = Number.isFinite(result.displayRate) && result.displayRate > 0 ? String(roundToCommercialRate(result.displayRate)) : '';
    }
    if (document.activeElement !== elements.revenue) {
      elements.revenue.value = Number.isFinite(result.displayRevenue) && result.displayRevenue > 0 ? String(roundToCommercialRate(result.displayRevenue)) : '';
    }
    if (document.activeElement !== elements.margin) {
      elements.margin.value = formatPercentInput(result.displayMarginPercent);
    }
    setText(elements.outputs.machine, result.equipmentLabel);
    setText(elements.outputs.machineCost, formatCurrency(result.machineBaseCost));
    setText(elements.outputs.machineTotal, formatCurrency(result.machineMarketValue));
    setText(elements.outputs.classLabel, `${result.classConfig.label} · ${result.classConfig.title}`);
    setText(elements.outputs.rateDesired, formatCurrency(result.displayRate));
    setText(elements.outputs.revenueTarget, formatCurrency(result.displayRevenue));
    setText(elements.outputs.monthsTheoretical, formatPercent(result.classConfig.targetMargin));
    setText(elements.outputs.monthsSelected, state.selectedMonths ? `${state.selectedMonths}` : '—');
    setText(elements.outputs.rateFinal, result.marginClassLabel);
    setText(elements.outputs.revenue, formatCurrency(result.displayRevenue));
    setText(elements.outputs.productsCost, formatCurrency(result.displayProductsCost));
    setText(elements.outputs.marginValue, formatCurrency(result.displayGrossMargin));
    setText(elements.outputs.marginPercent, formatPercent(result.displayMarginPercent));
    setText(elements.outputs.formula, result.activeMonths
      ? `${formatCurrency(result.displayRate)} × ${result.activeMonths} mesi = ${formatCurrency(result.displayRevenue)}`
      : `${formatCurrency(result.safeDesiredRate)} × ? mesi = seleziona una durata`);
    setText(elements.outputs.enteredMarginValue, formatCurrency(result.enteredGrossMargin));
    setText(elements.outputs.enteredMarginPercent, formatPercent(result.enteredMarginPercent));
    setText(elements.outputs.financialMarginValue, formatCurrency(result.financialMarginValue));
    setText(elements.outputs.financialMarginPercent, formatPercent(result.financialMarginPercent));
    updateAlertState(result);
  }

  function renderStatus(result) {
    const statusLabel = result.statusColor === 'green'
      ? 'Sostenibile'
      : result.statusColor === 'yellow'
        ? 'Borderline / da verificare'
        : 'Margine non sostenibile';

    elements.statusBadge.textContent = `Stato bozza · ${statusLabel}`;
    elements.statusBadge.classList.remove('is-green', 'is-yellow', 'is-red');
    elements.statusBadge.classList.add(`is-${result.statusColor}`);

    const detail = [
      state.selectedMonths
        ? state.activeMode === 'revenue'
          ? `Bozza commerciale su ${state.selectedMonths} mesi con rata ricalcolata a partire dal fatturato.`
          : `Bozza commerciale su ${state.selectedMonths} mesi con fatturato aggiornato in tempo reale su rata x mesi.`
        : `Inserisci una durata per leggere il calcolo su una base commerciale definita.`,
      result.durationValidation || ''
    ];
    elements.statusDetail.textContent = detail.filter(Boolean).join(' ');

    if (elements.commercialNote) {
      elements.commercialNote.textContent = buildCommercialNote(result);
      elements.commercialNote.classList.toggle('is-alert', result.statusColor === 'red');
      elements.commercialNote.classList.toggle('is-warn', result.statusColor === 'yellow');
      elements.commercialNote.classList.toggle('is-ok', result.statusColor === 'green');
    }
  }

  function buildCommercialNote(result) {
    if (!result.activeMonths) {
      return 'Seleziona una durata per ottenere una lettura commerciale della bozza.';
    }

    if (result.durationValidation) {
      return result.durationValidation;
    }

    if (result.isBelowMinimumMargin) {
      return `Bozza da rivedere: il margine stimato e ${formatPercent(result.displayMarginPercent)}, sotto la soglia minima ${formatPercent(MIN_SUSTAINABLE_MARGIN)}.`;
    }

    if (result.displayMarginPercent < result.classConfig.targetMargin) {
      return `Bozza sostenibile ma sotto target classe ${result.classConfig.label}: margine ${formatPercent(result.displayMarginPercent)} contro target ${formatPercent(result.classConfig.targetMargin)}.`;
    }

    return `Bozza sostenibile: ${formatCurrency(result.displayRate)} al mese per ${result.activeMonths} mesi, fatturato previsto ${formatCurrency(result.displayRevenue)} e margine stimato ${formatPercent(result.displayMarginPercent)}.`;
  }

  function updateAlertState(result) {
    const toggleAlert = (node, isAlert) => {
      if (!node) return;
      node.classList.toggle('is-alert', Boolean(isAlert));
    };

    const rateField = elements.rate ? elements.rate.closest('.ordine-rental__field') : null;
    const revenueField = elements.revenue ? elements.revenue.closest('.ordine-rental__field') : null;
    const monthsLabel = elements.outputs.monthsSelected ? elements.outputs.monthsSelected.closest('.ordine-rental__metric') : null;
    const revenueMetric = elements.outputs.revenue ? elements.outputs.revenue.closest('.ordine-rental__metric') : null;
    const marginValueMetric = elements.outputs.marginValue ? elements.outputs.marginValue.closest('.ordine-rental__metric') : null;
    const marginPercentMetric = elements.outputs.marginPercent ? elements.outputs.marginPercent.closest('.ordine-rental__metric') : null;
    const classMetric = elements.outputs.rateFinal ? elements.outputs.rateFinal.closest('.ordine-rental__metric') : null;

    const missingMonths = !result.activeMonths;
    const invalidRate = Boolean(result.rateValidation);
    const invalidRevenue = Boolean(result.revenueValidation);
    const invalidMargin = Boolean(result.marginValidation);
    const blockedDuration = Boolean(result.durationValidation);
    const unsustainable = !missingMonths && result.isBelowMinimumMargin;

    toggleAlert(rateField, invalidRate || unsustainable);
    toggleAlert(revenueField, invalidRevenue);
    toggleAlert(elements.margin ? elements.margin.closest('.ordine-rental__field') : null, invalidMargin);
    toggleAlert(monthsLabel, missingMonths || blockedDuration);
    toggleAlert(revenueMetric, missingMonths || blockedDuration);
    toggleAlert(elements.formulaBox, missingMonths || blockedDuration);
    toggleAlert(classMetric, unsustainable);
    toggleAlert(marginValueMetric, unsustainable);
    toggleAlert(marginPercentMetric, unsustainable);
    toggleAlert(elements.statusDetail, missingMonths || blockedDuration || unsustainable);
    toggleAlert(elements.summaryPanel, missingMonths || blockedDuration || unsustainable);
  }

  function renderPreview() {
    elements.previewAgreement.textContent = state.contract.agreementNumber || 'Da generare';
    Object.keys(elements.previewFields).forEach((field) => {
      elements.previewFields[field].forEach((node) => {
        node.textContent = state.contract[field] || '—';
      });
    });
    elements.deliveryPages.forEach((page) => {
      page.hidden = !state.includeDeliveryReport;
    });
  }

  function renderSavedState() {
    if (!state.updatedAt) {
      elements.savedState.textContent = 'Nessuna bozza salvata in questa sessione.';
      return;
    }

    const parts = [
      state.contract.agreementNumber || 'Bozza senza numero accordo',
      `Aggiornata il ${formatDateTime(state.updatedAt)}`
    ];

    if (state.proposalId) {
      parts.push(`ID bozza ${state.proposalId}`);
    }

    elements.savedState.textContent = parts.join(' · ');
  }

  function syncDerivedContractFields(precomputed) {
    const result = precomputed || computeState();
    const finalMonths = state.selectedMonths || '';
    const installationDate = state.contract.installationDate || '';
    const derivedProgramEnd = installationDate ? formatDate(addMonths(installationDate, finalMonths || 0)) : 'Da definire';
    const derivedProgramContent = `Programma Rental ELS – ${result.equipmentLabel} – ${finalMonths || 'da definire'} mesi – minimo mensile € ${formatCurrencyNumber(result.displayRate)} + IVA`;

    state.contract.agreementNumber = state.agreementNumber || '';
    state.contract.equipment = result.equipmentLabel;
    state.contract.machineValue = formatCurrency(result.machineMarketValue);
    state.contract.duration = finalMonths ? `${finalMonths} mesi` : '';
    state.contract.programEnd = installationDate ? derivedProgramEnd : 'Da definire';
    state.contract.monthlyMinimum = formatCurrency(result.displayRate);
    state.contract.toleranceMonths = state.contract.toleranceMonths || '2';

    if (!state.programContentDirty || !state.contract.programContent) {
      state.contract.programContent = derivedProgramContent;
    }
  }

  function computeState() {
    const machine = getCurrentMachine();
    const selectedMachines = getSelectedMachines();
    const classConfig = getCurrentClass();
    const safeDesiredRate = Math.max(parseNumber(state.desiredRate) || 0, MIN_RATE);
    const safeTargetRevenue = Math.max(parseNumber(state.targetRevenue) || 0, 0);
    const activeMonths = state.selectedMonths || null;
    const machineBaseCost = getSelectedMachinesBaseCost(selectedMachines);
    const machineMarketValue = computeMachineMarketValue(machineBaseCost);
    const machineCostForMargin = computeMachineCostForMargin(machineBaseCost, activeMonths);
    const requestedMargin = resolveRequestedMargin(classConfig);
    let finalRate = safeDesiredRate;
    let revenueTotal = activeMonths ? finalRate * activeMonths : 0;

    if (activeMonths && state.activeMode === 'revenue') {
      revenueTotal = safeTargetRevenue;
      finalRate = roundToCommercialRate(revenueTotal / activeMonths);
    } else if (activeMonths && (state.activeMode === 'margin' || state.activeMode === 'class')) {
      revenueTotal = revenueForMargin(machineCostForMargin, requestedMargin);
      finalRate = roundToCommercialRate(revenueTotal / activeMonths);
    } else if (activeMonths) {
      revenueTotal = finalRate * activeMonths;
    }
    const productsCost = revenueTotal * PRODUCT_COST_RATE;
    const grossMargin = revenueTotal - productsCost - machineCostForMargin;
    const marginPercent = revenueTotal > 0 ? grossMargin / revenueTotal : 0;
    const enteredRevenue = revenueTotal;
    const enteredProductsCost = enteredRevenue * PRODUCT_COST_RATE;
    const enteredGrossMargin = enteredRevenue - enteredProductsCost - machineCostForMargin;
    const enteredMarginPercent = enteredRevenue > 0 ? enteredGrossMargin / enteredRevenue : 0;
    const showEnteredScenario = Boolean(activeMonths);
    const displayRate = finalRate;
    const displayRevenue = showEnteredScenario ? enteredRevenue : revenueTotal;
    const displayProductsCost = showEnteredScenario ? enteredProductsCost : productsCost;
    const displayGrossMargin = showEnteredScenario ? enteredGrossMargin : grossMargin;
    const displayMarginPercent = showEnteredScenario ? enteredMarginPercent : marginPercent;
    const marginClassId = getMarginClassId(displayMarginPercent);
    const marginClassLabel = marginClassId ? `${marginClassId} · ${CLASS_CONFIG[marginClassId].title}` : 'Sotto margine minimo';
    const durationValidation = activeMonths && !isDurationAllowed(activeMonths, { displayRevenue })
      ? `Durata massima 48 mesi sotto ${formatCurrency(REVENUE_THRESHOLD_FOR_60_MONTHS)} di fatturato totale.`
      : '';
    const isBelowMinimumMargin = Boolean(activeMonths) && displayMarginPercent < MIN_SUSTAINABLE_MARGIN;
    const financialMarginValue = displayGrossMargin - (state.financialAdjustedValue || 0);
    const financialMarginPercent = displayRevenue > 0 ? financialMarginValue / displayRevenue : 0;
    const statusColor = durationValidation ? 'red' : resolveStatusColor(displayMarginPercent, classConfig, activeMonths);
    const isCompatible = Boolean(activeMonths) && !durationValidation && !isBelowMinimumMargin;
    const nextClassSuggestion = getNextClassId(classConfig.id);
    const rateValidation = state.activeMode === 'revenue'
      ? (activeMonths && finalRate > 0 && finalRate < MIN_RATE ? `Con questo fatturato la rata risultante scende sotto ${formatCurrency(MIN_RATE)}.` : '')
      : (parseNumber(state.desiredRate) < MIN_RATE ? `La rata minima inseribile è ${formatCurrency(MIN_RATE)}.` : '');
    const revenueValidation = state.activeMode === 'revenue' && safeTargetRevenue <= 0 ? 'Inserisci un fatturato maggiore di zero.' : '';
    const marginValidation = requestedMargin >= PRODUCT_MARGIN_RATE
      ? `Il margine deve essere inferiore a ${formatPercent(PRODUCT_MARGIN_RATE)}.`
      : '';

    return {
      machine,
      selectedMachines,
      equipmentLabel: getEquipmentLabel(selectedMachines),
      machineBaseCost,
      classConfig,
      machineTotalCost: machineMarketValue,
      machineMarketValue,
      machineCostForMargin,
      safeDesiredRate,
      safeTargetRevenue,
      finalRate,
      displayRate,
      activeMonths,
      revenueTotal,
      productsCost,
      grossMargin,
      marginPercent,
      enteredRevenue,
      enteredProductsCost,
      enteredGrossMargin,
      enteredMarginPercent,
      financialMarginValue,
      financialMarginPercent,
      displayRevenue,
      displayProductsCost,
      displayGrossMargin,
      displayMarginPercent,
      marginClassId,
      marginClassLabel,
      statusColor,
      isCompatible,
      isBelowMinimumMargin,
      durationValidation,
      nextClassSuggestion,
      rateValidation,
      revenueValidation,
      marginValidation,
      showEnteredScenario
    };
  }

  function resolveStatusColor(marginPercent, classConfig, activeMonths) {
    if (!activeMonths) return 'red';
    if (marginPercent < MIN_SUSTAINABLE_MARGIN) return 'red';
    if (marginPercent >= classConfig.targetMargin) return 'green';
    return 'red';
  }

  function getAutoEvaluationMonths(rate) {
    const config = getCurrentClass();
    const safeRate = Math.max(parseNumber(rate) || 0, MIN_RATE);
    if (config.presets.includes(36)) {
      const marginAt36 = computeCommercialMarginPercent(safeRate * 36, computeMachineCostForMargin(getSelectedMachinesBaseCost(getSelectedMachines()), 36));
      if (marginAt36 < config.targetMargin) return 36;
    }
    if (config.presets.includes(36)) return 36;
    return config.presets[config.presets.length - 1] || null;
  }

  function normalizeSelectionState() {
    const classConfig = getCurrentClass();
    const selectedMonths = parseInt(state.selectedMonths, 10) || null;

    if (selectedMonths && classConfig.presets.includes(selectedMonths) && isDurationAllowed(selectedMonths)) {
      state.selectedMonths = selectedMonths;
      if (!['revenue', 'margin', 'class'].includes(state.activeMode)) {
        state.activeMode = 'rate';
      }
      return;
    }

    const fallbackMonths = getAutoEvaluationMonths(state.desiredRate);
    state.selectedMonths = fallbackMonths;
    if (!fallbackMonths) {
      state.activeMode = 'rate';
    }
  }

  function saveProposal(fromGenerate) {
    syncDerivedContractFields();

    if (!state.proposalId) {
      state.proposalId = `rental-${Date.now()}`;
    }

    ensureAgreementNumber();

    const result = computeState();
    const proposals = readProposals();
    state.updatedAt = new Date().toISOString();

    proposals[state.proposalId] = {
      id: state.proposalId,
        agreementNumber: state.agreementNumber,
        machineId: state.machineId,
        secondaryMachineId: state.secondaryMachineId,
        classId: state.classId,
        desiredRate: state.desiredRate,
        targetRevenue: state.targetRevenue,
        targetMargin: state.targetMargin,
        financialAdjustedValue: state.financialAdjustedValue,
        selectedMonths: state.selectedMonths,
        activeMode: state.activeMode,
        includeDeliveryReport: state.includeDeliveryReport,
        includePrivacyModule: state.includePrivacyModule,
      contract: { ...state.contract },
      programContentDirty: state.programContentDirty,
        economics: {
        finalRate: result.finalRate,
        activeMonths: result.activeMonths,
        revenueTotal: result.revenueTotal,
        productsCost: result.productsCost,
        machineTotalCost: result.machineCostForMargin,
        machineValue: result.machineMarketValue,
        machineCostForMargin: result.machineCostForMargin,
        grossMargin: result.grossMargin,
        marginPercent: result.marginPercent,
        statusColor: result.statusColor
      },
      draftStatus: fromGenerate ? 'contract-generated' : 'saved',
      updatedAt: state.updatedAt
    };

    localStorage.setItem(STORAGE_KEYS.proposals, JSON.stringify(proposals));
    persistCurrentId(state.proposalId);
    render();
  }

  function nextAgreementNumber() {
    const year = new Date().getFullYear();
    const sequenceKey = `els_rental_sequence_${year}`;
    const current = parseInt(localStorage.getItem(sequenceKey) || '0', 10) || 0;
    const next = current + 1;
    localStorage.setItem(sequenceKey, String(next));
    return `${year}/RP/${String(next).padStart(4, '0')}`;
  }

  function ensureAgreementNumber() {
    if (state.agreementNumber) return state.agreementNumber;
    state.agreementNumber = nextAgreementNumber();
    state.contract.agreementNumber = state.agreementNumber;
    return state.agreementNumber;
  }

  function loadState() {
    const currentId = localStorage.getItem(STORAGE_KEYS.currentId);
    const proposals = readProposals();
    if (currentId && proposals[currentId]) {
      const saved = proposals[currentId];
      return {
        proposalId: saved.id || '',
        agreementNumber: saved.agreementNumber || '',
        machineId: saved.machineId || DEFAULT_STATE.machineId,
        secondaryMachineId: saved.secondaryMachineId && saved.secondaryMachineId !== saved.machineId ? saved.secondaryMachineId : '',
        classId: saved.classId || DEFAULT_STATE.classId,
        desiredRate: parseNumber(saved.desiredRate) || DEFAULT_STATE.desiredRate,
        targetRevenue: parseNumber(saved.targetRevenue) || DEFAULT_STATE.targetRevenue,
        targetMargin: Number.isFinite(parseNumber(saved.targetMargin)) && parseNumber(saved.targetMargin) > 0
          ? parseNumber(saved.targetMargin)
          : (CLASS_CONFIG[saved.classId] || CLASS_CONFIG[DEFAULT_STATE.classId]).targetMargin,
        financialAdjustedValue: parseNumber(saved.financialAdjustedValue) || 0,
        selectedMonths: saved.selectedMonths || null,
        activeMode: saved.activeMode === 'revenue' ? 'revenue' : 'rate',
        includeDeliveryReport: Boolean(saved.includeDeliveryReport),
        includePrivacyModule: Boolean(saved.includePrivacyModule),
        contract: { ...DEFAULT_CONTRACT, ...(saved.contract || {}) },
        programContentDirty: Boolean(saved.programContentDirty),
        updatedAt: saved.updatedAt || ''
      };
    }
    return createDefaultState();
  }

  function createDefaultState() {
    return {
      proposalId: '',
      agreementNumber: '',
      machineId: DEFAULT_STATE.machineId,
      secondaryMachineId: '',
      classId: DEFAULT_STATE.classId,
      desiredRate: DEFAULT_STATE.desiredRate,
      targetRevenue: DEFAULT_STATE.targetRevenue,
      targetMargin: CLASS_CONFIG[DEFAULT_STATE.classId].targetMargin,
      financialAdjustedValue: 0,
      selectedMonths: DEFAULT_STATE.selectedMonths,
      activeMode: 'rate',
      includeDeliveryReport: false,
      includePrivacyModule: false,
      contract: { ...DEFAULT_CONTRACT },
      programContentDirty: false,
      updatedAt: ''
    };
  }

  function readProposals() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEYS.proposals) || '{}');
    } catch (error) {
      return {};
    }
  }

  function persistCurrentId(id) {
    if (id) {
      localStorage.setItem(STORAGE_KEYS.currentId, id);
    } else {
      localStorage.removeItem(STORAGE_KEYS.currentId);
    }
  }

  function openWhatsAppShare() {
    const result = computeState();
    syncDerivedContractFields(result);
    const parts = [
      'Bozza Rental ELS',
      state.contract.agreementNumber ? `Accordo: ${state.contract.agreementNumber}` : 'Bozza cliente',
      state.contract.businessName ? `Cliente: ${state.contract.businessName}` : '',
      `Apparecchiature: ${result.equipmentLabel}`,
      `Valore apparecchiature: ${formatCurrency(result.machineMarketValue)}`,
      `Durata: ${state.selectedMonths || 'da definire'} mesi`,
      `Rata: ${formatCurrency(result.displayRate)} + IVA`,
      `Fatturato: ${formatCurrency(result.displayRevenue)}`,
      state.includeDeliveryReport ? 'Verbale di consegna: incluso' : '',
      state.includePrivacyModule ? 'Modulo privacy GDPR: da inviare/allegare' : ''
    ].filter(Boolean);

    window.open(`https://wa.me/${WHATSAPP_BUSINESS_NUMBER}?text=${encodeURIComponent(parts.join('\n'))}`, '_blank', 'noopener');
  }

  function setText(node, value) {
    if (!node) return;
    node.textContent = value;
  }

  function getCurrentMachine() {
    return MACHINE_OPTIONS.find((machine) => machine.id === state.machineId) || MACHINE_OPTIONS[0];
  }

  function getSelectedMachines() {
    const primary = getCurrentMachine();
    const secondary = MACHINE_OPTIONS.find((machine) => machine.id === state.secondaryMachineId);
    return secondary && secondary.id !== primary.id ? [primary, secondary] : [primary];
  }

  function getSelectedMachinesBaseCost(machines) {
    return machines.reduce((total, machine) => total + (Number(machine.cost) || 0), 0);
  }

  function getEquipmentLabel(machines) {
    return machines.map((machine) => machine.name).join(' + ');
  }

  function getCurrentClass() {
    return CLASS_CONFIG[state.classId] || CLASS_CONFIG.A;
  }

  function getNextClassId(classId) {
    const index = CLASS_SEQUENCE.indexOf(classId);
    return CLASS_SEQUENCE[index + 1] || '';
  }

  function getMarginClassId(marginPercent) {
    if (marginPercent >= CLASS_CONFIG.A.targetMargin) return 'A';
    if (marginPercent >= CLASS_CONFIG.B.targetMargin) return 'B';
    if (marginPercent >= CLASS_CONFIG.C.targetMargin) return 'C';
    if (marginPercent >= MIN_SUSTAINABLE_MARGIN) return 'C';
    return '';
  }

  function computeCommercialMarginPercent(revenue, machineTotalCost) {
    if (!revenue) return 0;
    const productsCost = revenue * PRODUCT_COST_RATE;
    const grossMargin = revenue - productsCost - machineTotalCost;
    return grossMargin / revenue;
  }

  function revenueForMargin(machineCostForMargin, marginPercent) {
    const denominator = PRODUCT_MARGIN_RATE - marginPercent;
    if (denominator <= 0) return 0;
    return machineCostForMargin / denominator;
  }

  function resolveRequestedMargin(classConfig) {
    const fallback = classConfig.targetMargin;
    if (state.activeMode === 'class') return fallback;
    const parsed = parseNumber(state.targetMargin);
    return clampMarginPercent(parsed || fallback);
  }

  function clampMarginPercent(value) {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) return MIN_SUSTAINABLE_MARGIN;
    return Math.min(Math.max(parsed, 0), 0.64);
  }

  function getMaintenanceCost(months) {
    const safeMonths = parseInt(months, 10) || 0;
    const contractYears = Math.max(1, Math.ceil(safeMonths / 12));
    return contractYears * ANNUAL_MAINTENANCE_COST;
  }

  function computeMachineMarketValue(baseCost) {
    return (Number(baseCost) || 0) * 3;
  }

  function computeMachineCostForMargin(baseCost, months) {
    return (Number(baseCost) || 0) + getMaintenanceCost(months);
  }

  function getCandidateRevenue(months) {
    const safeMonths = parseInt(months, 10) || 0;
    if (!safeMonths) return 0;
    return state.activeMode === 'revenue'
      ? Math.max(parseNumber(state.targetRevenue) || 0, 0)
      : Math.max(parseNumber(state.desiredRate) || 0, MIN_RATE) * safeMonths;
  }

  function isDurationAllowed(months, precomputed) {
    const safeMonths = parseInt(months, 10) || 0;
    if (safeMonths !== 60) return true;
    const revenue = precomputed && Number.isFinite(precomputed.displayRevenue)
      ? precomputed.displayRevenue
      : getCandidateRevenue(safeMonths);
    return revenue >= REVENUE_THRESHOLD_FOR_60_MONTHS;
  }

  function roundUpToStep(value, step) {
    if (!Number.isFinite(value) || value <= 0) return 0;
    return Math.ceil(value / step) * step;
  }

  function roundToCommercialRate(value) {
    if (!Number.isFinite(value) || value <= 0) return 0;
    return Math.round(value * 100) / 100;
  }

  function parseNumber(value) {
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function formatCurrency(value) {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0
    }).format(Number.isFinite(value) ? value : 0);
  }

  function formatCurrencyNumber(value) {
    return new Intl.NumberFormat('it-IT', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(Number.isFinite(value) ? value : 0);
  }

  function formatPercent(value) {
    return `${(Number.isFinite(value) ? value * 100 : 0).toFixed(2).replace('.', ',')}%`;
  }

  function formatPercentInput(value) {
    return (Number.isFinite(value) ? value * 100 : 0).toFixed(1).replace(/\.0$/, '');
  }

  function addMonths(dateValue, months) {
    const base = new Date(dateValue);
    if (!Number.isFinite(base.getTime()) || !months) return base;
    return new Date(base.getFullYear(), base.getMonth() + months, base.getDate());
  }

  function formatDate(dateValue) {
    const date = typeof dateValue === 'string' ? new Date(dateValue) : dateValue;
    if (!date || !Number.isFinite(date.getTime())) return '';
    return new Intl.DateTimeFormat('it-IT').format(date);
  }

  function formatDateTime(dateValue) {
    const date = new Date(dateValue);
    if (!Number.isFinite(date.getTime())) return '';
    return new Intl.DateTimeFormat('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
})();
